export const ONBOARDING__STEPS = [
  // {
  //   id: 0,
  //   title: "Manual & Automatic Price Updates",
  //   description:
  //     "Merchants can either enter daily gold rates manually or set a schedule (e.g., every 5 days) to automatically update product prices based on live gold rate data.",
  //   complete: false,
  //   image: {
  //     url: "https://cdn.shopify.com/shopifycloud/shopify/assets/admin/home/onboarding/shop_pay_task-70830ae12d3f01fed1da23e607dc58bc726325144c29f96c949baca598ee3ef6.svg", // Placeholder image
  //     alt: "Illustration of price updates",
  //   },
  //   primaryButton: {
  //     content: "Watch Demo",
  //     callAPI: false,
  //     redirect: false,
  //     props: {
  //       url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  //       external: true,
  //     }
  //   },
  // },
  {
    id: 0,
    title: "Metafield-Based Pricing Control",
    description:
      "Merchants can define key pricing elements like gold weight, making charges, and base price directly via product metafields — enabling automated, per-variant pricing logic.",
    complete: false,
    primaryButton: {
      content: "Create Metafield",
      callAPI: true,
      redirect: false
    },
    secondaryButton: {
      content: "Learn More",
      redirect: true,
      route: "/setup-metafield"
    },
  },
  {
    id: 1,
    title: "Built-in Analytics & Update History",
    description:
      "The app provides a transparent update log showing when prices were changed, how (manual or auto), and what the previous rates were — helping merchants stay informed and in control.",
    complete: false,
    primaryButton: {
      content: "Setup Auto Price Update",
      callAPI: true,
      redirect: false
    },
  },
  {
    id: 2,
    title: "Smart Pricing Automation",
    description:
      "The entire pricing process is automated — reducing manual effort, minimizing errors, and ensuring all gold-based products stay accurately priced at all times.",
    complete: false,
    primaryButton: {
      content: "View Pricing Plan",
      redirect: true,
      callAPI: false,
      route: "/pricing-plan"
    },
  },
];

export const METAFIELD_ATTRIBUTES_ITEMS = [
  {
    id: 0,
    title: 'Base Price (Integer)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Integer', 'base_price', 'custom.base_price', 'The base calculated price (based on weight and purity).'],
    ]
  },
  {
    id: 1,
    title: 'Making Charges (Integer)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Integer', 'charges', 'custom.charges', 'Additional fixed making charges for craftsmanship.'],
    ]
  },
  {
    id: 2,
    title: 'Weight (Decimal)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Decimal', 'weight', 'custom.weight', 'Actual weight of gold in grams.'],
    ]
  },
  {
    id: 3,
    title: 'Purity (Integer)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Integer', 'purity', 'custom.purity', 'Purity of gold (e.g., 18K, 22K, 24K).'],
    ]
  },
  {
    id: 4,
    title: 'VAT (Decimal)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Decimal', 'vat', 'custom.vat', 'VAT percentage to adjust effective gold weight.'],
    ]
  },
  {
    id: 5,
    title: 'Fixed Charge (Decimal)',
    headings: ['Type', 'Name', 'Namespace and key', 'Value'],
    rows: [
      ['Decimal', 'fixed_charge', 'custom.fixed_charge', 'A flat amount added to the price, used as fixedCharge in a custom formula.'],
    ]
  },
  // {
  //   id: 4,
  //   title: 'Unit (String)',
  //   headings: ['Type', 'Name', 'Namespace and key', 'Value'],
  //   rows: [
  //     ['String', 'unit', 'custom.unit', 'Measurement unit (default is grams).'],
  //   ]
  // },
];

export const SORT_OPTIONS = [
  { label: 'Date', value: 'date asc', directionLabel: 'Ascending' },
  { label: 'Date', value: 'date desc', directionLabel: 'Descending' }
];

export const PRICE_UPDATE_LOG_FILTERS = [
  'All',
  'Successful',
  'Failed',
  // 'Partially Successful'
];

export const PRICE_UPDATE_LOG_HEADINGS = [
  { title: 'Update Type' },
  { title: 'Interval Date' },
  { title: 'Status' },
  { title: 'Updated By' },
  { title: 'Interval Time' },
  { title: 'Action' }
];

export const INTERVAL_OPTIONS = [
  // { label: 'Minutes', value: 'minutes' },
  { label: 'Hours', value: 'hours' },
  { label: 'Days', value: 'days' },
  { label: 'Months', value: 'months' },
  { label: 'Years', value: 'years' }
];

export const SETUP_METAFIELDS_ITEMS = [
  {
    id: 0,
    heading: 'Step 1: Go to Your Product',
    description: 'In your Shopify admin, follow these steps:',
    steps: [
      'Navigate to <strong>Products</strong>.',
      'Open the product (e.g., a gold item) you’d like to configure.',
    ]
  },
  {
    id: 1,
    heading: 'Step 2: Open Variant',
    description: 'Follow these steps to open or create a variant:',
    steps: [
      'Open a variant if it exists (e.g., size, weight, color).',
      'If no variant exists, create a new one.',
    ]
  },
  {
    id: 2,
    heading: 'Step 3: Add Metafield Values',
    description: 'Follow these steps to add values to the required metafields:',
    steps: [
      'Scroll down to find the <strong>Metafields</strong> section.',
      'Add values to the following required fields:',
    ]
  }
];

export const DUMMY_PAYLOAD = {
  updateMethod: 'Manual',
  auto: {
    interval: {
      unit: 'days',
      value: 1
    },
    lastUpdate: new Date().toISOString(),
    nextUpdate: new Date(new Date().getTime() + 1 * 24 * 60 * 60 * 1000).toISOString()
  },
  priceSource: 'metafield',
  manual: {
    rates: {
      '10k': 0,
      '14k': 0,
      '16k': 0,
      '18k': 0,
      '20k': 0,
      '22k': 0,
      '24k': 0,
      "XAG": 0,
      "XPT": 0,
      "XPD": 0
    }
  }
};

export const REDIRECT_PATHS = [
  '/configure-products',
  '/setup-metafield',
  '/price-update-logs',
  '/contact-us',
  '/setting',
  '/pricing-plan',
  '/configure-products/:id',
  '/create-rule',
  '/rules',
  '/update-rule/:id'
];

export const NUMBER_OF_INTERVAL_OPTIONS = {
  // minutes: { min: 1, max: 60 },
  hours: { min: 1, max: 24 },
  days: { min: 1, max: 30 },
  months: { min: 1, max: 12 },
  years: { min: 1, max: 10 }
};

export const SETTING_TABS = [
  {
    id: 'auto-price-config',
    content: 'Auto Price Configuration',
    panelID: 'auto-price-config-content',
  },
  {
    id: 'gold-api-setup',
    content: 'Live Gold Rate API',
    panelID: 'gold-api-setup-content',
  },
  {
    id: 'metafield-mapping',
    content: 'Metafield Mapping',
    panelID: 'metafield-mapping-content',
  },
  // {
  //   id: 'general',
  //   content: 'General / Account',
  //   panelID: 'general-content',
  // },
];

export const METAFIELDS_DUMMY_DATA = [
  {
    "id": "1",
    "key": "making_charge",
    "value": "0",
    "namespace": "custom",
    "type": "number_integer"
  },
  {
    "id": "2",
    "key": "purity",
    "value": "0",
    "namespace": "custom",
    "type": "number_integer"
  },
  {
    "id": "3",
    "key": "weight",
    "value": "0",
    "namespace": "custom",
    "type": "number_decimal"
  },
  {
    "id": "4",
    "key": "base_price",
    "value": "0",
    "namespace": "custom",
    "type": "number_integer"
  },
  {
    "id": "5",
    "key": "unit",
    "value": "gram",
    "namespace": "custom",
    "type": "single_line_text_field"
  },
  {
    "id": "6",
    "key": "wastage",
    "value": "0.0",
    "namespace": "custom",
    "type": "number_decimal"
  },
  {
    "id": "7",
    "key": "fixed_charge",
    "value": "0.0",
    "namespace": "custom",
    "type": "number_decimal"
  }
]

export const METAFIELDS_HEADINGS = [
  { title: 'Type' },
  { title: 'Name' },
  { title: 'Namespace and key' },
  { title: 'Created at' },
  { title: 'Owner Type' },
  { title: 'Action' },
];

export const METAL_TYPES = [
  { label: 'Gold', value: 'gold' },
  // { label: 'Silver', value: 'silver' },
  // { label: 'Platinum', value: 'platinum' },
  // { label: 'Palladium', value: 'palladium' },
];

export const SKIPP_ACTIONS = ['Base Price', 'Wastage', 'Unit', 'Making Charge', 'Purity', 'Weight', 'VAT', 'Fixed Charge'];

export const RULE_STATUS = [
  { label: 'All', value: 'all', selected: 0 },
  { label: 'Active', value: 'active', selected: 1 },
  { label: 'Inactive', value: 'inactive', selected: 2 },
];

export const FORMULA_TYPES = [
  { label: 'Fixed (Type: Fixed)', value: 'fixed' },
  { label: 'Percentage (Type: Percentage)', value: 'percentage' },
  { label: 'Custom (Type: Custom)', value: 'custom' },
];

/* Variables a custom formula can use. Kept in sync with evaluateCustomFormula in
   server/src/utils/common.js — anything not listed here will not resolve. A store
   enabled for custom metafields also gets a variable per extra numeric metafield. */
export const FORMULA_VARIABLES = ['basePrice', 'weight', 'makingCharge', 'fixedCharge'];

/* Only numeric metafields can take part in arithmetic, so only these become variables. */
export const NUMERIC_METAFIELD_TYPES = ['number_integer', 'number_decimal'];

export const formulaVariablesHelpText = (variableNames = FORMULA_VARIABLES) =>
  `Our formula logic is based on the following variables: ${variableNames.join(', ')}. Each one is read from the matching product variant metafield, so fixedCharge lets one rule cover products with different flat charges. You can also use Math.round(), Math.ceil(), Math.floor() and Math.abs().`;

export const FORMULA_VARIABLES_HELP_TEXT = formulaVariablesHelpText();

export const ROUNDING_RULES = [
  { label: 'Nearest 1', value: 'nearest_1' },
  { label: 'Nearest 10', value: 'nearest_10' },
  { label: 'Nearest 100', value: 'nearest_100' },
  { label: 'Nearest 1000', value: 'nearest_1000' },
  { label: 'Nearest 10000', value: 'nearest_10000' },
];